import { isSsr } from './general';

export const getUserId = (): string | null =>
  isSsr ? null : window?.THDCustomer?.default?.userID;

export const getAuthorizationToken = (): string =>
  !isSsr ? window?.THDCustomer?.default?.token || '' : '';

export const getSvocId = (): string | null =>
  isSsr ? null : window?.THDCustomer?.default?.svocID;
